/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import ContentFaqTopic from '~/components/Content/Faq/Topic'

const FaqSection = ({ topic, title, description, bgOverride }) => {
  return (
    <Box bg={bgOverride} pt={[6, 7, 9]} pb={[7, 8, 10]}>
      <Container>
        <Grid columns={[1, 12]}>
          <Box sx={{ gridColumn: ['1 / -1', '2 / 12', '3 / 11'] }}>
            <Box sx={{ textAlign: 'center' }}>
              <Heading as="h2" mb={2} variant="title2">
                {title}
              </Heading>
              <Box
                variant="text.body1"
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            </Box>
            <Box mt={[5, 6, 7]}>
              <ContentFaqTopic topic={{ ...topic, name: null }} />
            </Box>
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default FaqSection
